import { config } from '@uhg-abyss/web/tools/config';

/**
 * msalConfig
 *
 * Necessary configuration to handle authentication.
 *
 * @type {{auth: {authority: `https://login.microsoftonline.com/${string}`, clientId: string,
 *     navigateToLoginRequestUrl: boolean, postLogoutRedirectUri: string, redirectUri: string}, cache: {cacheLocation:
 *     string, storeAuthStateInCookie: boolean}}}
 */
export const msalConfig = {
  auth: {
    authority: `https://login.microsoftonline.com/${config('NEXT_PUBLIC_AUTH_TENANT_ID')}`,
    clientId: config('NEXT_PUBLIC_AUTH_CLIENT_ID'),
    navigateToLoginRequestUrl: true,
    postLogoutRedirectUri: config('NEXT_PUBLIC_AUTH_LOGOUT_URI'),
    redirectUri: config('NEXT_PUBLIC_AUTH_REDIRECT_URI'),
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

/**
 * loginRequest
 *
 * Add here scopes for id token to be used at MS Identity Platform endpoints.
 *
 * @type {{scopes: *[]}}
 */
export const loginRequest = {
  scopes: [
    ...(config('NEXT_PUBLIC_AUTH_SCOPES')?.split('|') ?? []),
    ...(config('NEXT_PUBLIC_AUTH_TOKEN_SCOPES')?.split('|') ?? []),
  ],
};

/**
 * graphConfig
 *
 * Add here scopes for id token to be used at MS Identity Platform endpoints.
 *
 * @type {{graphMeEndpoint: string}}
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
